// Centralized API configuration
// This ensures the correct API URL is used in all environments

const getApiUrl = () => {
  // If we're on the production domain, use relative URL (same origin)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'www.marathon-edenlifeintl.org' || 
        hostname === 'marathon-edenlifeintl.org') {
      return '/api';
    }
  }
  
  // Otherwise use the environment variable (for development/preview)
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  return backendUrl ? `${backendUrl}/api` : '/api';
};

export const API_URL = getApiUrl();
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export default API_URL;
